import { type ObjectValuesUnionType } from '../utils/typing';

export const BetslipFilters = Object.freeze({
  ALL: 0,
  WON: 1,
  LOST: 2,
  RUNNING: 3,
  CANCELLED: 4,
  PENDING: 5,
  SETTLED: 6,
  FAVORITES: 7,
  HIDDEN: 8,
});
export type BetslipFilter = ObjectValuesUnionType<typeof BetslipFilters>;

export const BetslipTypes = Object.freeze({
  SINGLE: 1,
  MULTIPLE: 2,
  SYSTEM: 3,
  GRID: 4,
  BRACKET: 5,
  FANTASY: 6,
});
export type BetslipType = ObjectValuesUnionType<typeof BetslipTypes>;

export const BetslipStatus = Object.freeze({
  // TODO: Completer cet enum
  CANCELLED: 'CANCELLED',
  SETTLED: 'SETTLED',
  CASHOUT: 'CASHOUT',
  RUNNING: 'RUNNING',
  TRADER: 'TRADER',
  REJECTED: 'REJECTED',
  SPLITED: 'SPLITED', // Il y a une faute dans la variable renvoyée par le back
});
export type BetslipStatusType = ObjectValuesUnionType<typeof BetslipStatus>;

export const OutcomeStatuses = Object.freeze({
  RUNNING: 'RUNNING',
  WON: 'WON',
  LOST: 'LOST',
  CANCELLED: 'CANCELLED',
  LIVE: 'LIVE',
});
export type OutcomeStatus = ObjectValuesUnionType<typeof OutcomeStatuses>;

export const StatusFilters = Object.freeze({
  ...OutcomeStatuses,
  ALL: 'ALL',
});
export type StatusFilter = ObjectValuesUnionType<typeof StatusFilters>;

export const VoidReasons = Object.freeze({
  FORMAT_CHANGE: 'FORMAT_CHANGE',
  CANCELLED_EVENT: 'CANCELLED_EVENT',
  MATCH_ENDED_IN_WALKOVER: 'MATCH_ENDED_IN_WALKOVER',
  RETIRED_OR_DEFAULTED: 'RETIRED_OR_DEFAULTED',
  EVENT_REALLY_ABANDONED: 'EVENT_REALLY_ABANDONED',
  EVENT_REALLY_POSTPONED: 'EVENT_REALLY_POSTPONED',
  TOP_30_SKI: 'TOP_30_SKI',
  TOP_10_AUTO: 'TOP_10_AUTO',
  GOALSCORER_GUARANTEE: 'GOALSCORER_GUARANTEE',
  STARTING_5_GUARANTEE: 'STARTING_5_GUARANTEE',
  ANJ_FORBIDDEN: 'ANJ_FORBIDDEN',
  ANJ_TOP_50_FIFA: 'ANJ_TOP_50_FIFA',
  ANJ_NO_ENJEU: 'ANJ_NO_ENJEU',
  DEAD_HEAT_FACTOR: 'DEAD_HEAT_FACTOR',
});
export type VoidReason = ObjectValuesUnionType<typeof VoidReasons>;

export const BetslipNotableCases = Object.freeze({
  SINGLE_RUNNING_LOW: 1,
  SINGLE_RUNNING_MIDDLE: 2,
  SINGLE_RUNNING_HIGH: 3,
  COMBO_RUNNING_LOW: 4,
  COMBO_RUNNING_MIDDLE: 5,
  COMBO_RUNNING_HIGH: 6,
  SYSTEM_RUNNING: 7,
  MYMATCH_RUNNING: 8,
  SINGLE_WINNING_LOW: 9,
  SINGLE_WINNING_MIDDLE: 10,
  COTE_KILLER: 11,
  COMBO_WINNING_LOW: 12,
  COMBO_WINNING_MIDDLE: 13,
  MORTAL_COMBO: 14,
  SYSTEM_WINNING: 15,
  MYMATCH_LOW: 16,
  MAN_OF_MYMATCH: 17,
  SINGLE_LOST_LOW: 18,
  SINGLE_LOST_OTHER: 19,
  COMBO_LOST_ALL: 20,
  COMBO_LOST_ONE: 21,
  COMBO_LOST_OTHER: 22,
  SYSTEM_LOST: 23,
  MYMATCH_LOST: 24,
  CASHOUT_LOW: 25,
  CASHOUT_HEROES: 26,
  CASHOUT_OTHER: 27,
  CANCELLED: 28,
});
export type BetslipNotableCase = ObjectValuesUnionType<typeof BetslipNotableCases>;
